import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Button, Flex, LinkButton } from "@strapi/design-system"

interface FormButtonsProps {
  saveDisabled?: boolean
  loading?: boolean
  onSave: () => void
  cancelLink: string
}

const FormButtons = ({ saveDisabled, loading, onSave, cancelLink }: FormButtonsProps) => {
  const { t } = useTranslation()
  return (
    <Box style={{ padding: "10px 0" }}>
      <Flex gap={2}>
        <Button size="L" loading={loading} disabled={saveDisabled} onClick={onSave}>
          {t("save")}
        </Button>
        <LinkButton size="L" variant="secondary" href={cancelLink} target="_self">
          {t("cancel")}
        </LinkButton>
      </Flex>
    </Box>
  )
}

export default FormButtons
